import { DestinationChain } from "@/lib/chains";
import { CircularProgress } from "@mui/material";
import { MessageTableRow } from "lib/types";
import MessageRow from "./MessageRow";

export default function MessagesTable({
  rows,
  loading,
  latestHeadUpdates,
  lastFinalizedBlock,
}: {
  rows: MessageTableRow[];
  loading: boolean;
  latestHeadUpdates: Map<DestinationChain, number>;
  lastFinalizedBlock: number | null;
}) {
  const latestMsg =
    (rows && rows.length > 0 && rows[0] && rows[0][0]?.messageNonce) ||
    undefined;
  return (
    <div className="box-border w-full overflow-x-auto p-[1px]">
      <div className="w-fit min-w-full overflow-hidden rounded-md sm:-mx-6 md:mx-0 md:rounded-lg">
        <table className="w-full min-w-full table-fixed border-separate border-spacing-y-4 whitespace-nowrap">
          <thead className="rounded-lg">
            <tr
              className="ibm-plex-regular border-b text-left text-sm"
              style={{ color: "#C3DFE0", opacity: "40%" }}
            >
              <th className="w-[75px] py-3 px-3">NONCE</th>
              <th className="w-[130px] py-3 px-3">DESTINATION</th>
              <th className="w-[130px] py-3 px-3">TXN ORIGIN</th>
              <th className="w-[130px] py-3 px-3">MSG SENDER</th>
              <th className="w-[130px] py-3 px-3">MSG RECEIVER</th>
              <th className="w-[270px] py-3 px-3" colSpan={2}>
                SOURCE TXN
              </th>
              <th className="w-[275px] py-3 px-3" colSpan={2}>
                TARGET TXN
              </th>
              {/* <th className="w-[50px] py-3 px-3"></th> */}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-300">
            {loading && (
              <tr>
                <td colSpan={8}>
                  <div className="flex h-40 items-center justify-center text-white">
                    <CircularProgress size="60px" color="inherit" />
                  </div>
                </td>
              </tr>
            )}
            {!loading &&
              rows.map(([sentMessage, executedMessage], idx) => (
                <MessageRow
                  // sentMessage can be null in the case where the subgraph errored (due to bug in indexer code)
                  key={sentMessage?.messageNonce || latestMsg - idx}
                  messageNonce={sentMessage?.messageNonce || latestMsg - idx}
                  sourceTransaction={sentMessage}
                  targetTransaction={executedMessage}
                  latestHeadUpdates={latestHeadUpdates}
                  lastFinalizedBlock={lastFinalizedBlock}
                />
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
